/**
 *
 * zh-tw
 *
 * Taiwanese Mandarin locale labels
 */

export const Strings = {
  ADD_FROM_RECIPIENT_LIST: "選擇取貨人",
  SWITCH_ACCOUNT: "切換帳戶",
  CVV_ERROR_MSG: "請輸入有效 CVV 碼",
  CARD_ERROR_MSG: "請輸入有效卡號",
  EXPIRY_DATE_ERROR_MSG: "請輸入有效到期日",
  ACCOMPANYING_MOBILE_PHONE_TIPS: "請輸入09開頭10位數數字",
  PRODUCT_LOW_STOCKS: '除商品productNames庫存不足無法加入購物車，其他商品已成功加入購物車'
};
